import React, { memo, useCallback, useMemo } from "react";
import { useT, withRedux, WithReduxHocPropsType } from "@al/next/al-ex";
import { Button } from "@al/akui-mobile";
import cls from "classnames";

import linkTo from "~/common/utils/linkTo";
import { tracker } from "~/common/tracker";

import { SkuInfoType, ProductDetailType, SkuPriceType, OnlineStatus, IsSoldOut, SaleStockInfoType } from "../../types";
import { getTrackerSaReportInfo } from "../../../sensor-config";

import styles from "./styles.scss";
import { DisableTips } from "./constant";

interface Props extends WithReduxHocPropsType {
  detail: ProductDetailType;
  skuPrice: SkuPriceType;
  saleStockInfos: SaleStockInfoType[];
  currentSku: SkuInfoType;
  isSign: boolean;
  openAppLink: string;
}

const BottomBar: React.FC<Props> = (props) => {
  const t = useT();
  const { currentSku, detail, skuPrice, saleStockInfos } = props;

  const onBuyClick = useCallback(() => {
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickBuy" }),
    });
    props?.openAppLink && linkTo(props.openAppLink);
  }, [props?.openAppLink]);

  const onAddCart = useCallback(() => {
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickAddCart" }),
    });
    props?.openAppLink && linkTo(props.openAppLink);
  }, [props?.openAppLink]);

  // 当前选中 sku 的库存
  const currentSkuStock = useMemo(
    () => props.saleStockInfos?.find((item) => item.skuId === currentSku?.skuId)?.quantity || 0,
    [currentSku, props.saleStockInfos]
  );

  const tips = useMemo(() => {
    // 商品下架
    if (detail.status === OnlineStatus.GetOff) {
      return t(DisableTips.PRODUCT_OFF_SALE);
    }
    // 商品无库存(商品售罄，skuPrice 请求失败)
    if (detail.soldouted === IsSoldOut.Yes) {
      return t(DisableTips.PRODUCT_SOLD_OUT);
    }
    // 超出配送区域(当前 sku 无库存 或者所有 sku 的库存都为 0，标识该区域无货, 或者 sku-price 请求失败，)
    if (currentSkuStock === 0 || saleStockInfos?.every((item) => item.quantity === 0)) {
      return t(DisableTips.PRODUCT_OUT_OF_AREA);
    }
  }, [detail, skuPrice, currentSkuStock, saleStockInfos, t]);

  return (
    <div className={styles.box}>
      {tips && <div className={styles.tips}>{tips}</div>}
      <div className={styles.button_box}>
        <Button
          className={cls(styles.mb10, styles.btn, styles.add_cart)}
          disabled={!!tips}
          color="primary"
          block
          onClick={onAddCart}
        >
          {t("加入购物车")}
        </Button>
        <Button className={cls(styles.mb10, styles.btn)} disabled={!!tips} color="primary" block onClick={onBuyClick}>
          {t("立即购买")}
        </Button>
      </div>
    </div>
  );
};

export default withRedux((state) => ({
  currentSku: state.static.currentSku,
  skuPrice: state.static.skuPrice,
  saleStockInfos: state.static.saleStockInfos,
  isSign: state.sign.isSign,
  openAppLink: state.static.openAppLink,
}))(memo(BottomBar));
